import { render, staticRenderFns } from "./DistributionForm.vue?vue&type=template&id=74afafc2"
import script from "./DistributionForm.vue?vue&type=script&lang=js"
export * from "./DistributionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports